// mouseover event
// this will purely calculate what the 

const debounceDrag = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
}

class DragToReveal extends HTMLElement {
  constructor() {
    super()
    const handleEl = this.querySelector('.drag-to-reveal__post')

    this.topEl = this.querySelector('.drag-to-reveal__top')
    this.dragPosition = 0
    this.isDragging = false

    handleEl.addEventListener("mousedown", this.customDragStart.bind(this))
    this.addEventListener("mouseup", this.customDragEnd.bind(this))
    this.addEventListener("mousemove", this.movePosition.bind(this))
    this.addEventListener("mouseleave", this.customDragEnd.bind(this))
    
    this.addEventListener("touchstart", this.customDragStart.bind(this))
    this.addEventListener("touchend", this.customDragEnd.bind(this))
    this.addEventListener("touchmove", this.movePosition.bind(this))
    // this.addEventListener("touchmove", debounceDrag(this.movePosition.bind(this), 5))

    this.handleEl = handleEl

    // image swapping functionality
    const bottom = this.querySelector('[drag-to-reveal-bottom]')
    this.bottom = bottom
    this.top = this.querySelector('[data-to-reveal-top]')

    // we are grabbing both mobile and desktop with this setup
    this.swatchesM = document.querySelectorAll('image-w-swatches.hide-desktop.image-w-swatches--mobile button')
    this.swatchesD = this.querySelectorAll('.image-w-swatches__swatches.hide-mobile button')
    this.swatchTextD = document.querySelectorAll('.image-w-swatches__color-name p')
    this.setUpSwapEvents()
    this.loadImages()
    this.observeAnimate()
  }

  customDragStart() {
    const handle = this.querySelector('.drag-to-reveal__post-handle')
    if (handle) {
      handle.classList.remove('handle-animation')
    }
    this.isDragging = true
  }

  customDragEnd() {
    this.isDragging = false
  }

  movePosition(ev) {
    if (!this.isDragging) return

    const bounds = this.getBoundingClientRect();
    const x =
      ev.touches !== undefined
        ? ev.touches[0].clientX - bounds.left
        : ev.clientX - bounds.left;

    const position = (x / bounds.width) * 100;

    if (position >= 0 && position <= 100) {
      this.topEl.style.clipPath = `inset(0% 0% 0% ${position}%)`
      this.handleEl.style.transform = `translateX(${x - (bounds.width * 0.1)}px)`
    }
  }

  // image swapping functionality

  setUpSwapEvents() {
    this.swatchesD.forEach(el => {
      el.addEventListener('click', () => {
        const colorCombo = el.dataset.colorCombo
        const text = el.dataset.colorText

        // get template for lifestyle and arrow images
        const newLifeStyle = this.querySelector(`#lifestyle-image__${colorCombo}`)
        const newArrow = this.querySelector(`#arrow-image__${colorCombo}`)

        this.bottom.style.height = this.bottom.offsetHeight + 'px'

        this.bottom.innerHTML = newLifeStyle.innerHTML
        this.top.innerHTML = newArrow.innerHTML

        this.swatchesD.forEach(swatch => {
          if (swatch.dataset.colorCombo === colorCombo) {
            swatch.classList.add('image-w-swatches__swatch--active')
          } else {
            swatch.classList.remove('image-w-swatches__swatch--active')
          }
        })

        this.swatchesM.forEach(swatch => {
          if (swatch.dataset.colorCombo === colorCombo) {
            swatch.classList.add('image-w-swatches__swatch--active')
          } else {
            swatch.classList.remove('image-w-swatches__swatch--active')
          }
        })

        
        this.swatchTextD.forEach(swatchText => {
          swatchText.textContent = text
        })
      })
    })


    this.swatchesM.forEach(el => {
      const colorCombo = el.dataset.colorCombo
      const text = el.dataset.colorText

      el.addEventListener('click', () => {

        // get template for lifestyle and arrow images
        const newLifeStyle = this.querySelector(`#lifestyle-image__${colorCombo}`)
        const newArrow = this.querySelector(`#arrow-image__${colorCombo}`)

        this.bottom.style.height = this.bottom.offsetHeight + 'px'

        this.bottom.innerHTML = newLifeStyle.innerHTML
        this.top.innerHTML = newArrow.innerHTML

        this.swatchesD.forEach(swatch => {
          if (swatch.dataset.colorCombo === colorCombo) {
            swatch.classList.add('image-w-swatches__swatch--active')
          } else {
            swatch.classList.remove('image-w-swatches__swatch--active')
          }
        })

        this.swatchesM.forEach(swatch => {
          if (swatch.dataset.colorCombo === colorCombo) {
            swatch.classList.add('image-w-swatches__swatch--active')
          } else {
            swatch.classList.remove('image-w-swatches__swatch--active')
          }
        })
        
        this.swatchTextD.forEach(swatchText => {
          swatchText.textContent = text
        })
      })
    })
  }

  loadImages() {
    const images = document.querySelectorAll('.template__image')
    const isMobile = window.matchMedia("(max-width: 768px)").matches


    window.addEventListener('load', function(event) {
      // images[i] = new Image();
      images.forEach(template => {
        const fragment = template.content
        if (isMobile) {
          const mobileImg = fragment.querySelector('img.hide-desktop')
          if (mobileImg) {
            const preload = new Image()
            preload.sizes = mobileImg.sizes
            preload.srcset = mobileImg.srcset
            preload.src = mobileImg.src
          }
        } else {
          const desktopImg = fragment.querySelector('img.hide-mobile')
          if (desktopImg) {
            const preload = new Image()
            preload.sizes = desktopImg.sizes
            preload.srcset = desktopImg.srcset
            preload.src = desktopImg.src
          }
        }
      })
    })
  }

  observeAnimate() {
    const handle = this.querySelector('.drag-to-reveal__post-handle')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('drag-to-reveal--animate-move')
          setTimeout(() => {
            handle.classList.add('handle-animation')
            entry.target.classList.remove('drag-to-reveal--animate')
            // entry.unobserve()
          }, 2000)
        }
      })
    }, {
      threshold: 0.5
    })

    observer.observe(this)
  }
}

customElements.define('drag-to-reveal', DragToReveal)